/* globals document, window */
import React, { Component, Fragment } from "react";
import { GlobalProvider } from "../common/GlobalContext";
import GlobalAlert from "../common/GlobalAlert";
import AgentDetailLayout from "./AgentDetailLayout";
import AgentProfile from "./AgentProfile";
import AgentListings from "./AgentListings";
import Testimonials from "../common/Testimonials";

import type { $Agent } from "flow/types";

type Props = {
  alerts: Array<Object>,
  agent: $Agent,
  aboutBio: string,
  myListings: Object,
  soldListings: Object,
  testimonials: Array<Object>,
  favorites: Array<number>,
  compliance: Object,
  siteUser: Object,
  theme: Object, // theme from the API/site settings, not the react-jss theme
};

class AgentDetail extends Component<Props, State> {
  render() {
    const {
      agent,
      aboutBio,
      myListings,
      soldListings,
      testimonials,
      favorites,
      compliance,
      siteUser,
      theme,
      alerts,
    } = this.props;
    return (
      <GlobalProvider
        theme={theme}
        compliance={compliance}
        favorites={favorites}
        siteUser={siteUser}
      >
        <Fragment>
          <GlobalAlert alerts={alerts} />
          <AgentDetailLayout>
            <AgentProfile agent={agent} agentBio={aboutBio} />
            <AgentListings
              myListings={myListings}
              soldListings={soldListings}
            />
            <Testimonials testimonials={testimonials} />
          </AgentDetailLayout>
        </Fragment>
      </GlobalProvider>
    );
  }
}

export default AgentDetail;
